import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  AndroidIcon,
  IphoneIcon,
  BackendIcon,
  CPAppIcon,
} from "../../../app-constants";

const StackItem = [
  {
    icon: IphoneIcon,
    title: "iOS App Development",
    description:
      "SwiftLint, Objective-C, RxSwift, CircleCI, Swift, SwiftUI, CocoaPods.",
  },
  {
    icon: AndroidIcon,
    title: "Android App Development",
    description:
      "Java, Kotlin, Fastlane, Gradle, Coroutines, Dagger2, JetPack.",
  },
  {
    icon: CPAppIcon,
    title: "Cross-platform App Development",
    description:
      "TypeScript, React Native, Javascript, Flutter, Native Script.",
  },
  {
    icon: BackendIcon,
    title: "Backend Development",
    description: "Node.js, Ruby on Rail (RoR), Python, Firebase.",
  },
];

function Technology(props) {
  return (
    <div className="technoloy_sec p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="">
            <div className="example" data-text="Tech">
              <h2>Our Tech Stack for Mobile App Development Indianapolis</h2>
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1"
          >
            <p>
              As a top-tier company for mobile app development Indianapolis, we
              use a wide range of technologies to meet your specific needs. We
              have a diverse team of expert developers who have enough
              experience working in the technologies mentioned below:
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={11} xxl={11} className="m-auto">
            <div className="technology_main">
              {StackItem.map((item, index) => (
                <div className="technology_item">
                  <div className="svg_icon">{item.icon}</div>
                  <h6>{item.title}</h6>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Technology;
